import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { ConectorProvider } from "../../providers/conector/conector";

@Component({
  selector: "page-otros",
  templateUrl: "otros.html",
})
export class OtrosPage {
  pestanya = "formacion";
  formacion = [];
  uniformes = [];
  llaves = [];
  data = {
    background: "assets/images/background/39.jpg",
  };
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private conector: ConectorProvider
  ) {
    this.conector.getOtros().subscribe((data) => {
      console.log("otros", data);
      this.formacion = data["formacion"];
      this.uniformes = data["uniformes"];
      this.llaves = data["llaves"];
    });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad OtrosPage");
  }
}



// WEBPACK FOOTER //
// ./src/pages/otros/otros.ts